import { render, staticRenderFns } from "./detailService.vue?vue&type=template&id=15845036&scoped=true"
import script from "./detailService.vue?vue&type=script&lang=js"
export * from "./detailService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15845036",
  null
  
)

export default component.exports